const MIME_TYPES = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  csv: 'text/csv',
  zip: 'application/zip',
  rar: 'application/x-rar-compressed',
  tar: 'application/x-tar',
  gz: 'application/gzip',
  json: 'application/json',
  txt: 'text/plain',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  mp4: 'video/mp4',
  avi: 'video/x-msvideo',
  mov: 'video/quicktime',
  mkv: 'video/x-matroska',
  flv: 'video/x-flv',
  webm: 'video/webm',
  ogg: 'audio/ogg',
  jsonld: 'application/jsonld',
  svg: 'image/svg+xml',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  tiff: 'image/tiff',
  webp: 'image/webp',
  ico: 'image/vnd.microsoft.icon',
  heic: 'image/heic',
  heif: 'image/heif',
  eps: 'application/postscript',
  psd: 'application/vnd.adobe.photoshop',
  ai: 'application/postscript',
  ind: 'application/indesign',
  indd: 'application/indesign',
  xcf: 'application/x-xcf',
  obj: 'model/obj',
  xml: 'text/xml',
};

export default MIME_TYPES;
